define('google_charts',[],function() {
    return {
        load: function(commaSeparatedPackageNames, req, onLoad, config) {
            if (config.isBuild) {
                // Skip if we're building.
                onLoad(null);
            } else {
                req(["https://www.gstatic.com/charts/loader.js"], function() {
                    google.charts.load("current", {
                        packages: commaSeparatedPackageNames.split(/\s*,\s*/),
                    });
                    google.charts.setOnLoadCallback(onLoad);
                });
            }
        },
    };
});

